import $ from 'jquery'
import TarifActe from '@/views/parametres/tarifications/tarif-acte'
import TarifChambre from '@/views/parametres/tarifications/tarif-chambre'
import TarifObservation from '@/views/parametres/tarifications/tarif-observation'
import TarifAdmission from '@/views/parametres/tarifications/tarif-admission'
import TarifConsommable from '@/views/parametres/tarifications/tarif-consommable'
import TypeFacturationChoix from '@/components/type-facturation-choix'
import listesPaginees from '@/api/parametres/_listes-paginees.js'
import { nouvelleListe, chargerPage, rechercherDiffere, rechargerDepuisDebut } from '@/utils/liste-paginee.js'

/**
 * Liste paginée d'une section, avec un marqueur "à recharger" (section masquée par le filtre Prestation
 * au moment d'un changement d'assurance / de type : rechargée à son prochain affichage)
 */
function listeSection() {
	return Object.assign(nouvelleListe(), { a_recharger: false, page_demandee: 0 })
}

export default {
	name: 'tarifications',
	components: {
		TarifActe, TarifChambre, TarifObservation,
		TarifAdmission, TarifConsommable, TypeFacturationChoix
	},
	props: [],
	data() {
		return {
			// Groupe assurance
			group_assur_select: '',
			// assurance_select: '',
			assurance_select: {
				compagnie: 'Choisir une assurance',
				compagnie_id: -1
			},
			can_show_assur: false,

			tarif_filter: [
				{
                    libelle: 'Tous',
                    id: '0',
                },
                {
                    libelle: 'Consultations généralistes',
                    id: '1',
                },
                {
                    libelle: 'Consultations spécialistes',
                    id: '2',
                },
				{
                    libelle: 'Chirurgies',
                    id: '3',
                },
                {
                    libelle: 'Analyses',
                    id: '4',
                },
				{
                    libelle: 'Examens',
                    id: '5',
                },
				{
                    libelle: 'Médicaments',
                    id: '6',
                },
				{
                    libelle: 'Consommables',
                    id: '7',
                },
				{
                    libelle: 'Bilan de santé',
                    id: '8',
                },
				{
					libelle: 'Actes',
                    id: '9',
				},
				{
					libelle: 'Chambres',
                    id: '10',
				},
				{
					libelle: 'Observations',
                    id: '11',
				},
				{
					libelle: 'Admissions',
                    id: '12',
				}
            ],

			moment_consultation: [
				{
					id: 1,
					denomination: 'Jour'
				},
				{
					id: 2,
					denomination: 'Nuit'
				},
				{
					id: 3,
					denomination: 'Férié'
				},
				{
					id: 4,
					denomination: 'Garde'
				},
				{
					id: 5,
					denomination: 'Urgence'
				}
			],

			filtre_tarif: '',
			// Filtre Type facturation (Analyses, Examens, Chirurgies, Actes) : '' (Tous), 'normal' ou 'urgence'
			filtre_type_facturation: '',

			type_prestation_to_add: '',

			// ###### v-model Tarif Consultation
			c_prestation: {
				type_consultation_id: 0,
				categorie_consultation: 0,
				id: 0,
				libelle: '',
				lettre_cle: '',
				coef: '',
				moment: {
					id: '',
					denomination: ''
				},
				type_facturation: 'normal',
				prix_non_assure: '',
				prix_assure_clinique: '',
				groupe_assur_id: '',
				assurance_id: '',
				code_prod_assurance: ''
			},
			is_new: true,
			is_edit: false,
			can_add_moment: false,
			can_add_type_facturation: false,
			can_add_coef: true,
			show_prix: 0,				//	0 => None   |  1 => Only CAT  |  2 => CAT & ONMT   |  3 => Only INAM
			can_show_prix: true,
			can_show_lettre_cle: true,
			can_show_param_pu: true,

			// ###### v-model Autre Tarif ( Chirurgies, Analyses... )
			autre_prestation: {
				id: 0,
				libelle: '',
				lettre_cle: '',
				coef: '',
				prix_non_assure: '',
			},

			// >>>>>>>>>>  Tarif Consultation Générale
			fields: [
				'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
				'actions'
			],
			p_fields: [
				'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
			],

			fields_chirurg: [
				'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
				'actions'
			],
			p_fields_chirurg: [
				'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
				'actions'
			],
			print_per_page: -1,
			// >>>------------------------------------

			// Listes paginées côté serveur : une par section (page, recherche et chargement propres à chacune)
			liste_consult_gen: listeSection(),
			liste_consult_spec: listeSection(),
			liste_analyses: listeSection(),
			liste_examens: listeSection(),
			// Chirurgies : la pagination porte sur les chirurgies (chaque chirurgie affiche toutes ses lignes K)
			liste_chirurgies: listeSection(),
			liste_medicaments: listeSection(),
			liste_bilans_sante: listeSection(),

			save_loading: false,
			btn_disable: false,
			loading: false,
			options: { placeholder: "Choisir une option" },

			del_categorie_consultation: 0,

			// PU CAT / ONMT
			pu_cat_onmt: {
				type_prestation: '',
				id: 0,
				libelle: '',
				lettre_cle: '',
				pu_cat: '',
				pu_onmt: '',
				pu_inam: '',
				groupe_assur_id: '',
				assurance_id: ''
			},
			pu_loading: true,

			// >>>>>>>>>>>>... Suppression
			tarif_to_be_deleted: {
				tarif_id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            all_checked: false,
            one_is_checked: [],
            text_grey: [],
			is_all_assur: false,

			is_printing_consul_gen: false,
			is_printing_consul_spec: false,
			is_printing_analyse: false,
			is_printing_examen: false,
			is_printing_med: false,
            is_printing_chirurgie: false,
			is_printing_bilan: false,
            filename: '',
            p_printing: '',

			editing_acte_tarif_data: {},
			editing_chambre_tarif_data: {},
			editing_observation_tarif_data: {},
			editing_admission_tarif_data: {},
			editing_consommable_tarif_data: {},
			is_zero: false,
			can_print: false,
			libelle_tarif: "",
			tarif_prestations: [],
			p_data_type: ''
		}
	},

	watch: {
		assurance_select() {
			this.choixAssurance()
		},

		// Type normal / urgence : Analyses, Examens et Chirurgies rechargés depuis la page 1 (Actes : dans TarifActe)
		filtre_type_facturation() {
			this.rechargerSections(['analyse', 'examen', 'chirurgie'])
		}
	},

	computed: {
		prix_unitaire_cat_onmt() {
            return this.$store.getters["prix_unitaire_cat_onmt"];
        },

		groupe_assurs() {
            return this.$store.getters["groupe_assurs"];
        },

		assurance_sans_groupe() {
            return this.$store.getters["assurance_sans_groupe"];
        },

		types_facturation_prestation() {
            return this.$store.getters["types_facturation_prestation"];
        },

		// Valeurs proposées dans la modal ('normal' | 'urgence')
		types_facturation_values() {
			return this.types_facturation_prestation.map((type) => type.value)
		},

		// Options du filtre "Type" de l'en-tête
		type_facturation_filter() {
			let options = [{ value: '', libelle: 'Tous' }]
			this.types_facturation_prestation.forEach((type) => {
				options.push({ value: type.value, libelle: this.libelleTypeFacturation(type.value) })
			})
			return options
		},

		type_facturation_filtre() {
			return this.filtre_type_facturation || ''
		},

		// Chirurgies de la page courante (lignes K déjà filtrées par le serveur selon le type)
		chirurgies_affichees() {
			return this.filtrerChirurgiesParType(this.liste_chirurgies.lignes)
		},

		// Sections visibles selon le filtre Prestation (id de la classe .tarif-{id})
		section_visible() {
			const id_selected = (this.filtre_tarif)?this.filtre_tarif.id:0
			let visibles = {}
			for (let i = 1; i <= 12; i++) {
				visibles[i] = !(id_selected > 0) || id_selected == i
			}
			return visibles
		},
	},
	mounted() {
		this.$store.dispatch("getGroupeAssurance").then(() => {
			let select_autre = {
				groupe_id: 0,
				groupe: 'Autre'
			}
			this.groupe_assurs.push(select_autre)
		})

		this.$store.dispatch("getAssuranceSansGroupe").then(() => {
			let all_assur = {
				compagnie_id: 0,
				compagnie: 'Toutes les assurances'
			}

			const sans_assur = {
				compagnie_id: -1,
				compagnie: 'Pas d\'assurance'
			}
			this.assurance_sans_groupe.push(all_assur)
			this.assurance_sans_groupe.push(sans_assur)
		})

		/**
		 * Types de facturation (normal / urgence) des Analyses, Examens, Chirurgies et Actes
		 */
		this.$store.dispatch("getTypesFacturationPrestation")

		/**
		 * Première page de chaque section (consultations, analyses, examens, chirurgies, médicaments, bilans de santé)
		 */
		this.rechargerSections(['consultation_gen', 'consultation_spec', 'analyse', 'examen', 'chirurgie', 'medicament', 'bilan_sante'])

		var d = new Date()
		var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

		this.filename = 'Tarification_prestation_'+tmpstamp
	},
	methods: {
		formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

		/**
		 * Libellé affiché d'un type de facturation ('normal' => 'Normal')
		 * @param {*} type_facturation
		 */
		libelleTypeFacturation(type_facturation) {
			if (!type_facturation) {
				return ''
			}
			return type_facturation.charAt(0).toUpperCase() + type_facturation.slice(1)
		},

		/**
		 * Prestations facturables en normal / urgence
		 * @param {*} type_prestation
		 */
		accepteTypeFacturation(type_prestation) {
			return ['analyse', 'examen', 'chirurgie', 'acte'].includes(type_prestation)
		},

		/**
		 * Garde les lignes du type sélectionné dans l'en-tête (toutes si "Tous")
		 * @param {*} lignes
		 */
		filtrerParTypeFacturation(lignes) {
			if (this.type_facturation_filtre == '') {
				return lignes
			}
			return lignes.filter((ligne) => {
				return !ligne.type_facturation || ligne.type_facturation == this.type_facturation_filtre
			})
		},

		toutSelectionner() {
            let is_checked = $('#assur-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.assurance_sans_groupe.forEach((data) => {
                    this.one_is_checked.push(data.compagnie_id)
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false
            }
        },

        onOneChange() {
            // let is_checked = $('#assur'+index).is(":checked")

            // let c = ''
            // if (is_checked == true) {
            //     c = 'text-grey'
            // }
            // this.text_grey[index] = c

            document.getElementById("assur-tous").checked = false;
        },

		choixAssurance() {
			this.can_show_param_pu = false
			let compagnie = (this.assurance_select.compagnie_id > 0)?this.assurance_select.compagnie:''

			if (this.assurance_select.compagnie_id == 0) {
				this.is_all_assur = true
			} else {
				this.is_all_assur = false
			}

			if (this.assurance_select.compagnie_id == -1) {
				this.can_show_prix = false
				this.show_prix = 0

				this.fields = [
					'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
					'actions'
				]

				this.p_fields = [
					'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' }, 'actions'
				]

				this.fields_chirurg = [
					'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
					'actions'
				],
				this.p_fields_chirurg = [
					'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
					'actions'
				]
			} else {
				if (this.can_set_pac) {
					this.fields = [
						'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assure_clinique', label: 'Prix assuré' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, 
						{ key: 'code_prod_assurance', label: 'Code assur.' }, 'actions'
					]

					this.p_fields = [
						'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assure_clinique', label: 'Prix assuré' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, { key: 'code_prod_assurance', label: 'Code assur.' },
					]

					this.fields_chirurg = [
						'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assure_clinique', label: 'Prix assuré' }, 
						{ key: 'prix_assur', label: 'Base '+compagnie }, 
						{ key: 'code_prod_assurance', label: 'Code assur.' }, 'actions'
					],
					this.p_fields_chirurg = [
						'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assure_clinique', label: 'Prix assuré' }, { key: 'prix_assur', label: 'Base '+compagnie },
						{ key: 'code_prod_assurance', label: 'Code assur.' }
					]
				} else {
					this.fields = [
						'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, 
						{ key: 'code_prod_assurance', label: 'Code assur.' }, 
						{ key: 'code_prod_assurance', label: 'Code assur.' }, 'actions'
					]

					this.p_fields = [
						'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, { key: 'code_prod_assurance', label: 'Code assur.' }
					]

					this.fields_chirurg = [
						'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, 
						{ key: 'code_prod_assurance', label: 'Code assur.' }, 'actions'
					],
					this.p_fields_chirurg = [
						'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, { key: 'code_prod_assurance', label: 'Code assur.' },
					]
				}
				this.show_prix = 3
			}

			// Toutes les sections reviennent à la page 1 (les sous-composants surveillent eux-mêmes l'assurance)
			this.rechargerSections(['consultation_gen', 'consultation_spec', 'analyse', 'chirurgie', 'examen', 'medicament', 'bilan_sante'])
		},

		/**
		 * Prix unitaire CAT / ONMT
		 * @param {*} slug_prestation 
		 */
		getPrixUnitairePrestation(slug_prestation) {
			this.pu_loading = true

			this.type_prestation_to_add = slug_prestation
			let filter = {
				slug_prestation: slug_prestation,
				groupe_id: this.group_assur_select.groupe_id,
				assurance_id: this.assurance_select.compagnie_id
			}
			this.$store.dispatch("getPrixUnitaireCatOnmt", filter).then(() => {
				this.pu_loading = false

				this.pu_cat_onmt = {
					type_prestation: this.type_prestation_to_add,
					id: this.prix_unitaire_cat_onmt.id,
					libelle: this.prix_unitaire_cat_onmt.libelle,
					lettre_cle: this.prix_unitaire_cat_onmt.lettre_cle,
					pu_cat: this.prix_unitaire_cat_onmt.pu_cat,
					pu_onmt: this.prix_unitaire_cat_onmt.pu_onmt,
					pu_inam: this.prix_unitaire_cat_onmt.pu_inam,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					}
				}
			});
		},

		/**
		 * Assurance envoyée aux grilles tarifaires (0 = sans assurance)
		 */
		assurIdTarif() {
			return (this.assurance_select.compagnie_id > 0)?this.assurance_select.compagnie_id:0
		},

		/**
		 * Complète les paramètres avec le type de facturation choisi dans l'en-tête (rien si "Tous")
		 * @param {*} params
		 */
		avecTypeFacturation(params) {
			if (this.type_facturation_filtre != '') {
				params.type_facturation = this.type_facturation_filtre
			}
			return params
		},

		/**
		 * Section inline : sa liste paginée, l'id de sa classe .tarif-{id}, l'appel API (sans paramètres = liste
		 * complète, pour l'impression), le filtre normal / urgence et l'indicateur d'impression
		 * @param {*} type_prestation
		 */
		sectionTarif(type_prestation) {
			const assur_id = this.assurIdTarif()
			const sections = {
				consultation_gen: {
					liste: this.liste_consult_gen, id: 1, par_type: false, impression: 'is_printing_consul_gen',
					appel: (params) => listesPaginees.tarifConsultations(1, assur_id, params)
				},
				consultation_spec: {
					liste: this.liste_consult_spec, id: 2, par_type: false, impression: 'is_printing_consul_spec',
					appel: (params) => listesPaginees.tarifConsultations(2, assur_id, params)
				},
				chirurgie: {
					liste: this.liste_chirurgies, id: 3, par_type: true, impression: 'is_printing_chirurgie',
					appel: (params) => listesPaginees.tarifChirurgies(assur_id, params)
				},
				analyse: {
					liste: this.liste_analyses, id: 4, par_type: true, impression: 'is_printing_analyse',
					appel: (params) => listesPaginees.tarifAnalyses(assur_id, params)
				},
				examen: {
					liste: this.liste_examens, id: 5, par_type: true, impression: 'is_printing_examen',
					appel: (params) => listesPaginees.tarifExamens(assur_id, params)
				},
				medicament: {
					liste: this.liste_medicaments, id: 6, par_type: false, impression: 'is_printing_med',
					appel: (params) => listesPaginees.tarifMedicaments(assur_id, params)
				},
				bilan_sante: {
					liste: this.liste_bilans_sante, id: 8, par_type: false, impression: 'is_printing_bilan',
					appel: (params) => listesPaginees.tarifBilansSante(assur_id, params)
				}
			}
			return sections[type_prestation]
		},

		/**
		 * Charge la page courante d'une section
		 * @param {*} type_prestation
		 */
		chargerSection(type_prestation) {
			const section = this.sectionTarif(type_prestation)
			if (!section) {
				return
			}
			section.liste.a_recharger = false
			section.liste.page_demandee = section.liste.page

			return chargerPage(section.liste, (params) => {
				return section.appel((section.par_type)?this.avecTypeFacturation(params):params)
			})
		},

		/**
		 * Recharge des sections depuis la page 1 (assurance, type changés).
		 * Une section masquée par le filtre Prestation sera rechargée à son prochain affichage.
		 * @param {*} types_prestation
		 */
		rechargerSections(types_prestation) {
			types_prestation.forEach((type_prestation) => {
				const section = this.sectionTarif(type_prestation)
				if (this.section_visible[section.id]) {
					rechargerDepuisDebut(section.liste, () => this.chargerSection(type_prestation))
				} else {
					section.liste.page = 1
					section.liste.page_demandee = 1
					section.liste.a_recharger = true
				}
			})
		},

		/**
		 * Pagination (@input) : charge la page choisie (ignore la remise à 1 faite par le rechargement)
		 * @param {*} type_prestation
		 */
		changerPage(type_prestation) {
			const liste = this.sectionTarif(type_prestation).liste
			if (liste.page != liste.page_demandee) {
				this.chargerSection(type_prestation)
			}
		},

		/**
		 * Recherche serveur d'une section (libellé de la prestation)
		 * @param {*} type_prestation
		 */
		rechercher(type_prestation) {
			rechercherDiffere(this.sectionTarif(type_prestation).liste, () => this.chargerSection(type_prestation))
		},

		/**
		 * Section sans aucune donnée (hors recherche en cours)
		 * @param {*} liste
		 */
		estVide(liste) {
			return !liste.chargement && !liste.erreur && liste.total == 0 && liste.q == ''
		},

		/**
		 * Chirurgies : garde les lignes K du type choisi ; une chirurgie sans ligne K de ce type n'est pas affichée
		 * @param {*} chirurgies
		 */
		filtrerChirurgiesParType(chirurgies) {
			if (this.type_facturation_filtre == '') {
				return chirurgies
			}
			return chirurgies.map((chirurgie) => {
				return Object.assign({}, chirurgie, {
					kchirurgies: this.filtrerParTypeFacturation(chirurgie.kchirurgies || [])
				})
			}).filter((chirurgie) => chirurgie.kchirurgies.length > 0)
		},

		/**
		 * Recharge la page courante d'une catégorie de consultation (1 : généralistes, 2 : spécialistes)
		 * @param {*} categorie_id
		 */
		refreshConsultation(categorie_id) {
			this.chargerSection((categorie_id == 1)?'consultation_gen':'consultation_spec')
		},

		/**
		 * Recharge la page courante d'une section (après enregistrement d'un tarif)
		 * @param {*} type_prestation
		 */
		refreshPrestation(type_prestation) {
			this.chargerSection(type_prestation)
		},

		onFilterTarif() {
			// Liste vidée : toutes les sections
			let id_selected = (this.filtre_tarif)?this.filtre_tarif.id:0

			if (id_selected > 0) {
				for(let i = 1; i <= this.tarif_filter.length; i++) {
					if (i != id_selected ) {
						$('.tarif-'+i).fadeOut(500)
					}
				}
				setTimeout(() => {
					$('.tarif-'+id_selected ).fadeIn(500)
				}, 500);
			} else {
				for(let i = 1; i <= this.tarif_filter.length; i++) {
					$('.tarif-'+i).fadeIn(500)
				}
			}

			// Sections de nouveau affichées dont l'assurance / le type a changé entre-temps
			// (les sous-composants le font eux-mêmes via la prop "visible")
			const types_prestation = ['consultation_gen', 'consultation_spec', 'analyse', 'chirurgie', 'examen', 'medicament', 'bilan_sante']
			types_prestation.forEach((type_prestation) => {
				const section = this.sectionTarif(type_prestation)
				if (section.liste.a_recharger && this.section_visible[section.id]) {
					this.chargerSection(type_prestation)
				}
			})
		},

		/**
		 * Ajouter un type de prestation
		 * @param {*} categorie_consultation 
		 * @param {*} type_prestation 
		 */
		addPrestation (categorie_consultation, type_prestation) {
			this.is_new = true
			this.is_edit = false
			this.type_prestation_to_add = type_prestation

			this.c_prestation = {
				type_consultation_id: 0,
				categorie_consultation: categorie_consultation,
				id: 0,
				libelle: '',
				lettre_cle: '',
				coef: '',
				moment: {
					id: 1,
					denomination: 'Jour'
				},
				type_facturation: 'normal',
				prix_non_assure: '',
				prix_assure_clinique: '',
				groupe_assur_id: {
					groupe_id: this.group_assur_select.groupe_id,
					groupe: this.group_assur_select.groupe
				},
				assurance_id: {
					compagnie: this.assurance_select.compagnie,
					compagnie_id: this.assurance_select.compagnie_id
				},
				code_prod_assurance: ''
			}

			if (type_prestation == 'consultation') {
				this.can_add_moment = true
				this.can_add_coef = false
				this.can_show_prix = true
				this.can_show_lettre_cle = true
			} else {
				this.can_add_moment = false
				this.can_add_coef = true
				this.can_show_prix = false
				this.can_show_lettre_cle = false
			}
			this.can_add_type_facturation = this.accepteTypeFacturation(type_prestation)

		},

		clearError() {
			this.is_zero = false
		},

		editTarifPrestation(tarif_data) {
			this.edit(tarif_data.data, tarif_data.type_prestation)
		},

		closeTarifModal() {
			this.save_loading = false
			this.btn_disable = false
			this.$refs.modal_prestation.click()
		},

		editTarifActe(tarif_data) {
			this.edit(tarif_data.data, tarif_data.type_prestation)
		},

		edit (data, type_prestation) {
			this.is_edit = true
			this.type_prestation_to_add = type_prestation
			this.can_show_lettre_cle = true
			this.can_add_type_facturation = this.accepteTypeFacturation(type_prestation)

			this.can_show_prix = true
			this.one_is_checked = []
			this.all_checked = false
			this.text_grey = []
			// document.getElementById("assur-tous").checked = false;

			if (type_prestation == 'consultation') {
				this.is_new = false
				this.can_add_moment = true
				this.can_add_coef = false

				this.c_prestation = {
					type_consultation_id: data.type_consultation_id,
					categorie_consultation: data.categorie_consultation_id,
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: data.moment_id,
						denomination: data.moment
					},
					prix_non_assure: data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			} else if (type_prestation == 'analyse') {
				this.is_new = true
				this.can_add_moment = false
				this.can_add_coef = false

				this.c_prestation = {
					type_consultation_id: 0,
					categorie_id: data.categorie_id,
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: 0,
						denomination: ''
					},
					type_facturation: data.type_facturation || 'normal',
					// Prix urgence non configuré => null
					prix_non_assure: (data.prix_non_assure == null)?'':data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			} else if (type_prestation == 'examen') {
				this.is_new = true
				this.can_add_moment = false
				this.can_add_coef = false

				this.c_prestation = {
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: 0,
						denomination: ''
					},
					type_facturation: data.type_facturation || 'normal',
					// Prix urgence non configuré => null
					prix_non_assure: (data.prix_non_assure == null)?'':data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			}  else if (type_prestation == 'acte') {
				this.is_new = true
				this.can_add_moment = false
				this.can_add_coef = false

				this.c_prestation = {
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: 0,
						denomination: ''
					},
					type_facturation: data.type_facturation || 'normal',
					prix_non_assure: (data.prix_non_assure == '-' || data.prix_non_assure == null)?'':data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: 0,
						groupe: ''
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			} else if (type_prestation == 'medicament') {
				this.is_new = false
				this.can_add_moment = false
				this.can_add_coef = false
				this.can_show_lettre_cle = false

				this.c_prestation = {
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: 0,
						denomination: ''
					},
					prix_non_assure: data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			} else if (type_prestation == 'bilan_sante') {
				this.is_new = true
				this.can_add_moment = false
				this.can_add_coef = false

				this.c_prestation = {
					id: data.id,
					libelle: data.libelle,
					lettre_cle: '',
					coef: '',
					moment: {
						id: 0,
						denomination: ''
					},
					prix_non_assure: data.pu,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			} else if (
				type_prestation == 'acte' || type_prestation == 'chambre' || type_prestation == 'observation' || 
				type_prestation == 'admission' || type_prestation == 'consommable'
			) {
				this.is_new = true
				this.can_add_moment = false
				this.can_add_coef = false

				this.c_prestation = {
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: 0,
						denomination: ''
					},
					prix_non_assure: (data.prix_non_assure == '-')?'':data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: 0,
						groupe: ''
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			}
		},

		/**
		 * Edit Tarification Chirurgie
		 */
		editTarifChirurgie(data, chirurgie_id) {
			this.type_prestation_to_add = 'chirurgie'
			this.is_edit = true
			
			this.is_new = false
			this.can_add_moment = false
			this.can_add_coef = true
			this.can_add_type_facturation = true

			this.c_prestation = {
				chirurgie_id: chirurgie_id,
				id: data.k_id,
				libelle: data.k_chirurgie,
				lettre_cle: '',
				coef: (data.k_coef == '-')?'':data.k_coef,
				type_facturation: data.type_facturation || 'normal',

				prix_non_assure: (data.pu == null)?'':data.pu,
				prix_assure_clinique: data.prix_assure_clinique,
				prix_assur: data.prix_assur,
				groupe_assur_id: {
					groupe_id: this.group_assur_select.groupe_id,
					groupe: this.group_assur_select.groupe
				},
				assurance_id: {
					compagnie: this.assurance_select.compagnie,
					compagnie_id: this.assurance_select.compagnie_id
				},
				code_prod_assurance: data.code_prod_assurance
			}
		},

		/**
		 * Enregistrer Prestation
		 * @returns 
		 */
		async submitPrestation() {
			const isValid = await this.$refs.observer.validate();
			
            if (!isValid) {
                return;
            }

			if (this.show_prix == 3 && this.can_set_pac) {
				this.c_prestation.prix_assure_clinique = this.cleanNumber(this.c_prestation.prix_assure_clinique)
				this.c_prestation.prix_assur = this.cleanNumber(this.c_prestation.prix_assur)

				if (this.c_prestation.prix_assure_clinique  === 0) {
					this.is_zero = true
					return;
				}
			}

			if (this.c_prestation.prix_assure_clinique == '-' || this.c_prestation.prix_assure_clinique == '') {
				this.c_prestation.prix_assure_clinique = null
			}

			if (this.c_prestation.prix_assur == '-' || this.c_prestation.prix_assur == '') {
				this.c_prestation.prix_assur = null
			}
			
			this.c_prestation.grp_assurances = this.one_is_checked			

			this.save_loading = true
            this.btn_disable = true
			
			if (this.type_prestation_to_add == 'consultation') {
				// ------>>>>>>>>>  ENREGISTREMENT CONSULTATION
				this.$store.dispatch("addConsultationPrestation", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
						this.refreshConsultation(1)
						this.refreshConsultation(2)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'analyse') {
				this.$store.dispatch("addAnalysePrestation", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'chirurgie') {
				this.$store.dispatch("addChirurgiePrestation", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'examen') {
				this.$store.dispatch("saveExamenPara", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'medicament') {
				this.$store.dispatch("saveMedicament", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'bilan_sante') {
				this.$store.dispatch("saveTarifBilanSante", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'acte') {
				this.editing_acte_tarif_data = this.c_prestation
			} else if (this.type_prestation_to_add == 'chambre') {
				this.editing_chambre_tarif_data = this.c_prestation
			} else if (this.type_prestation_to_add == 'observation') {
				this.editing_observation_tarif_data = this.c_prestation
			} else if (this.type_prestation_to_add == 'admission') {
				this.editing_admission_tarif_data = this.c_prestation
			} else if (this.type_prestation_to_add == 'consommable') {
				this.editing_consommable_tarif_data = this.c_prestation
			}
		},

		afterSubmission(type_prestation) {
			this.refreshPrestation(type_prestation);

			if (this.is_new == true) {
				this.successToast('Tarif ajouté avec succès')
			} else {
				this.successToast('Tarif modifié avec succès')
			}
			$('.modal').modal('hide')
			
			this.c_prestation = {
				type_consultation_id: 0,
				categorie_consultation: 0,
				id: 0,
				libelle: '',
				lettre_cle: '',
				coef: '',
				moment: {
					id: 1,
					denomination: 'Jour'
				},
				type_facturation: 'normal',
				prix_non_assure: '',
				prix_assure_clinique: '',
				groupe_assur_id: '',
				assurance_id: '',
				code_prod_assurance: ''
			}
		},

		/**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data 
		 */
		remove(data) {
			this.tarif_to_be_deleted = {
                tarif_id: data.id,
                libelle: data.nom_prestation+' ( '+data.moment+' )',
            }
			this.del_categorie_consultation = data.categorie_consultation_id
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteTarifConsultation', this.tarif_to_be_deleted).then((response) => {
                    
                    if (response > 0) {
                        this.successToast('Tarif supprimé avec succès')
                    }

					this.refreshConsultation(this.del_categorie_consultation);
					$('.modal').modal('hide')
                    this.del_loading = false;
                    this.is_confirm = false
                })
            }
        },

		/**
		 * Save Prix Unitaire CAT / ONMT
		 */
		async submitPrixUnitaire() {
			const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.btn_disable = true

            this.$store.dispatch("updatePrixCatOnmt", this.pu_cat_onmt).then((response) => {
                if (response > 0) {
					this.successToast('Prix CAT / ONMT modifié avec succès')
					$('.modal').modal('hide')

					if (this.type_prestation_to_add == 'consultation_generaliste') {
						this.refreshConsultation(1)
					} else if (this.type_prestation_to_add == 'consultation_specialiste') {
						this.refreshConsultation(2)
					} else {
						this.refreshPrestation(this.type_prestation_to_add);
					} 
					// else if (this.type_prestation_to_add == 'analyse') {
					// 	this.refreshPrestation(this.type_prestation_to_add);
					// }
                    
                    this.pu_cat_onmt = {
						type_prestation: '',
						id: 0,
						libelle: '',
						lettre_cle: '',
						pu_cat: '',
						pu_onmt: '',
						pu_inam: '',
						groupe_assur_id: '',
						assurance_id: ''
					}
					this.$refs.observer.reset();
                } else {
					// TODO
					// Afficher msg d'erreur
                }
				this.save_loading = false
                this.btn_disable = false
            })
		},

		setToPrint(to_print) {
			
			this.p_printing = to_print

			if (to_print == 'consultation_gen') {
                this.is_printing_consul_gen = true

                setTimeout(() => {
                    this.is_printing_consul_gen = false
                }, 1500);
            } else if (to_print == 'consultation_spec') {
                this.is_printing_consul_spec = true

                setTimeout(() => {
                    this.is_printing_consul_spec = false
                }, 1500);
            } else if (to_print == 'analyse') {
                this.is_printing_analyse = true

                setTimeout(() => {
                    this.is_printing_analyse = false
                }, 1500);
            } else if (to_print == 'examen') {
                this.is_printing_examen = true

                setTimeout(() => {
                    this.is_printing_examen = false
                }, 1500);
            } else if (to_print == 'medicament') { ///////////////////
                this.is_printing_med = true

                setTimeout(() => {
                    this.is_printing_med = false
                }, 1500);
            } else if (to_print == 'chirurgie') {
                this.is_printing_chirurgie = true

                setTimeout(() => {
                    this.is_printing_chirurgie = false
                }, 1500);
            } else if (to_print == 'bilan_sante') {
                this.is_printing_bilan = true

                setTimeout(() => {
                    this.is_printing_bilan = false
                }, 1500);
            }
		},

		/**
		 * Impression d'une section : charge sa liste complète (même endpoint, sans pagination), applique le type
		 * normal / urgence de l'en-tête, puis imprime
		 * @param {*} data_type
		 */
		setPrestationToPrint(data_type) {
			const section = this.sectionTarif(data_type)
			if (!section || this[section.impression]) {
				return
			}
			this[section.impression] = true

			section.appel().then((reponse) => {
				// Sans pagination : la liste complète (tableau)
				let prestations = Array.isArray(reponse) ? reponse : ((reponse && Array.isArray(reponse.data)) ? reponse.data : [])

				if (data_type == 'chirurgie') {
					prestations = this.filtrerChirurgiesParType(prestations)
				} else if (section.par_type) {
					prestations = this.filtrerParTypeFacturation(prestations)
				}

				this.printTarifByPrestation({
					data_type: data_type,
					prestations: prestations
				})
			}).catch(() => {
				this.errorToast("Une erreur s'est produite lors du chargement de la liste à imprimer !")
			}).finally(() => {
				this[section.impression] = false
			})
		},

		printTarifByPrestation(data) {
			this.p_data_type = data.data_type
			this.tarif_prestations = data.prestations
			if (data.data_type == 'consommable') {
				this.libelle_tarif = 'Tarif Consommables'
			} else if (data.data_type == 'acte') {
				this.libelle_tarif = 'Tarif Actes'
			} else if (data.data_type == 'chambre') {
				this.libelle_tarif = 'Tarif Chambres'
			} else if (data.data_type == 'observation') {
				this.libelle_tarif = 'Tarif Observations'
			} else if (data.data_type == 'admission') {
				this.libelle_tarif = 'Tarif Admissions'
			} else if (data.data_type == 'bilan_sante') {
				this.libelle_tarif = 'Bilan de santé'
			} else if (data.data_type == 'medicament') {
				this.libelle_tarif = 'Tarif Médicaments'
			} else if (data.data_type == 'examen') {
				this.libelle_tarif = 'Tarif Examens'
			} else if (data.data_type == 'analyse') {
				this.libelle_tarif = 'Tarif Analyses'
			} else if (data.data_type == 'consultation_spec') {
				this.libelle_tarif = 'Tarif Consultations spécialistes'
			} else if (data.data_type == 'consultation_gen') {
				this.libelle_tarif = 'Tarif Consultations généralistes'
			} else if (data.data_type == 'chirurgie') {
				this.libelle_tarif = 'Tarif Chirurgies'
			}			

			this.can_print = true
            setTimeout(() => {
                window.print()

                this.can_print = false
            }, 500);
		}
	}
}


